
import React from "react";
import { Footprints } from "lucide-react";
import { cn } from "@/lib/utils";
import { getStandardPipClasses } from "./progressPipUtils";

interface StandardProgressPipProps {
  pipValue: number;
  isActive: boolean;
  isHovered: boolean;
  pipSizeClass: string;
  iconSizeClass: string;
  size: "sm" | "md" | "lg";
  darkMode: boolean;
  readonly: boolean;
  onPipClick?: (pipValue: number) => Promise<boolean>;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
}

const StandardProgressPip: React.FC<StandardProgressPipProps> = ({
  pipValue,
  isActive,
  isHovered,
  pipSizeClass,
  iconSizeClass,
  size,
  darkMode,
  readonly,
  onPipClick,
  onMouseEnter,
  onMouseLeave,
  onClick
}) => {
  return (
    <div 
      className={getStandardPipClasses(pipSizeClass, isActive, isHovered, darkMode, readonly, onPipClick)}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      role={!readonly && onPipClick ? "button" : undefined}
      tabIndex={!readonly && onPipClick ? 0 : undefined}
      aria-label={!readonly && onPipClick ? `Set progress to ${pipValue}` : undefined}
    >
      {/* Content */}
      <div className="relative z-10 flex items-center justify-center">
        {isActive ? (
          <Footprints className={cn(iconSizeClass, "text-white")} />
        ) : (
          <div className={cn(
            "rounded-full border border-current opacity-40",
            {
              "w-2 h-2": size === "sm",
              "w-3 h-3": size === "md", 
              "w-4 h-4": size === "lg"
            }
          )} />
        )}
      </div>

      {/* Gentle hover overlay */}
      {!readonly && isHovered && (
        <div className="absolute inset-0 transition-opacity duration-300 rounded-inherit bg-purple-300/20" />
      )}
    </div>
  );
};

export default StandardProgressPip;
